import React from "react"
import PropTypes from "prop-types"
import { Link } from "./styles"

const OptionsPopupLink = ({ children, id, onClick, brand, href }) => (
  <Link onClick={onClick} href={href} key={id} data-id={id} data-brand={brand}>
    {children}
  </Link>
)

OptionsPopupLink.PropTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  id: PropTypes.string,
  brand: PropTypes.string
}

export default OptionsPopupLink
